import { Injectable } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { OrderReceiptSetup } from 'src/app/POS/models/order-receipt-setup';
import { OrderTypeSetup } from 'src/app/POS/models/order-type-setup';
import { CommonFunctionService, UserPOSData } from '../../../services/Common/common-function.service';
import { OrderSetup } from '../../models/order-setup';
import { catchError, map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class OrderService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid();
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  GetOrderTypeList(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetOrderTypeListUrl + "?PosSubscriptionId=" + data, { headers: this.headers })
      .pipe(map(response => response))
  }

  // GetOrderTypeDetail(data) {
  //   return this.service
  //     .getAll(environment.GetOrderTypeDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id)
  //     .map(response => response);
  // }
  GetOrderTypeDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<OrderTypeSetup>(environment.GetOrderTypeDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId + "&id=" + data.id, { headers: this.headers })
      .pipe(map(response => response))
      .pipe(catchError(this.common.handleError));
  }


  AddOrderType(data) {
    this.GetGeaderdetails();
    return this.http.post(environment.AddOrderTypeUrl, data, { headers: this.headers });
  }

  UpdateOrderType(data) {
    this.GetGeaderdetails();
    return this.http.post(
      environment.UpdateOrderTypeUrl, data, { headers: this.headers });
  } 

  // GetOrderSetupDetail(data) {
  //   return this.service
  //     .getAll(environment.GetOrderSetupDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id)
  //     .map(response => response);
  // }

  GetOrderSetupDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetOrderSetupDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId + "&id=" + data.id, { headers: this.headers })
      .pipe(map(response => response))
      .pipe(catchError(this.common.handleError));
  }

  AddOrderSetup(data) {
    this.GetGeaderdetails();
    return this.http.post(environment.AddOrderSetupUrl, data, { headers: this.headers });
  }

  UpdateOrderSetup(data) {
    this.GetGeaderdetails();
    return this.http.post(
      environment.UpdateOrderSetupUrl, data, { headers: this.headers });
  }


  GetOrderReceiptDetail(data) {
    // return this.service
    //   .getAll(environment.GetOrderReceiptDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id)
    //   .map(response => response);

    return this.http.get<OrderReceiptSetup>(environment.GetOrderReceiptDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId + "&id=" + data.id, { headers: this.headers })
      .pipe(map(response => response))
      .pipe(catchError(this.common.handleError));
  }

  AddOrderReceipt(data) {
    this.GetGeaderdetails();
    return this.http.post(environment.AddOrderReceiptUrl, data, { headers: this.headers });
  }

  UpdateOrderReceipt(data) {
    this.GetGeaderdetails();
    return this.http.post(
      environment.UpdateOrderReceiptUrl, data, { headers: this.headers });
  }


  GetOrderSetupList(data) {
    this.GetGeaderdetails();
    return this.http
      .post(environment.GetOrderSetupListUrl + "?PosSubscriptionId=" + data, { headers: this.headers })
      .pipe(map(response => response))
  }



  GetOrderReceiptlist(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetOrderReceiptlistUrl + "?PosSubscriptionId=" + data, { headers: this.headers })
      .pipe(map(response => response));

  }

  GetGeaderdetails() {
    let loggedUsername = this.common.getUserName()
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid();
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));

  }
}







